import { render, staticRenderFns } from "./PageCart.vue?vue&type=template&id=a1ae2890"
import script from "./PageCart.vue?vue&type=script&lang=js"
export * from "./PageCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports